// Open roles, managed via the CMS. Leave empty when nothing is open; the page shows a general application form.
export type Role = {
  id: string;
  title: string;
  department: "Teaching" | "Student Support" | "Operations" | "Boarding";
  type: "Full-time" | "Part-time" | "Contract";
  location: string;
  summary: string;
  closes?: string;
};

export const OPEN_ROLES: Role[] = [];

export const CAREERS_EMAIL = "hello@maplecc.ca";

export const WHY_MCC = [
  { title: "A Canadian curriculum team", copy: "Work alongside Canadian-certified teachers and instructional coaches." },
  { title: "Students who aim high", copy: "Teach a focused Grade 10 to 12 cohort preparing for top global universities." },
  { title: "A modern Lekki campus", copy: "Purpose-built classrooms, labs, library and study spaces." },
];
